.styledInput {
    border-radius: var(--mantine-radius-sm);
    border: 1px solid var(--mantine-color-dark-3);
    background: var(--mantine-color-dark-5);
    font-size: var(--mantine-font-size-xs);
}

.disabledInput {
    border-radius: var(--mantine-radius-sm);
    border: 1px solid #a5aaaf1a;
    background: #333f481f;
    color: var(--mantine-color-dark-3);
    font-size: var(--mantine-font-size-xs);
}

.enabledButton,
.enabledButton:hover {
    background: var(--mantine-color-primary-6);
    color: var(--mantine-color-dark-0);
    border: none;
}

.disabledButton {
    background: #d5d6da1f;
}

.saleViewContainer {
    width: 100%;
    overflow-y: auto;
    height: 100%;
    flex-direction: column;
}

@keyframes slideIn {
    from {
        height: 0;
    }
    to {
        height: 56px;
    }
}

@keyframes fade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.warning {
    max-width: 376;
    padding: 12px 16px;
    margin: 14px 14px 0px 14px;
    border-radius: 4px;
    background: #c92a2a4d;
    animation: slideIn 400ms ease-in-out 0s 1 forwards normal;
}

.fade {
    animation: fade 400ms ease-in-out 0s 1 forwards normal;
}

@keyframes topSpacer {
    from {
        margin-top: -70px;
    }
    to {
        margin-top: 0px;
    }
}

.animationSpacer {
    animation: topSpacer 400ms ease-out 0s 1 forwards;
    margin-top: 0px;
}

.footerBox {
    background-color: var(--mantine-color-dark-4);
    width: 100%;
    height: var(--customer-panel-bottom-control-footer-height);
    position: absolute;
    bottom: 0;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border-radius: 0 0 var(--mantine-radius-md) var(--mantine-radius-md);
}

.scrollArea {
    height: calc(100% - var(--customer-panel-bottom-control-footer-height));
    position: relative;
}
